import { render, staticRenderFns } from "./OauthDone.vue?vue&type=template&id=3ca2e89e"
import script from "./OauthDone.vue?vue&type=script&lang=js"
export * from "./OauthDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports